// extracted by mini-css-extract-plugin
export var formControl = "MotherMenuSearchForm-module--formControl--e59b4";
export var search = "MotherMenuSearchForm-module--search--68325";
export var searchForm = "MotherMenuSearchForm-module--searchForm--9d665";